module.exports = __webpack_public_path__ + "img/微信图片_20200402154621.adda5b18.png";